









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";

import SignalRHub from "@/services/SignalRHub";

import DetailPane from "@/views/DetailPane.vue";
import { ReferralType } from "@/types/types";

@Component({
  components: {
    "referral-details": DetailPane,
  },
})
export default class ReferralView extends Vue {
  @Prop({ default: null })
  referralId!: string;

  @Prop({ default: null })
  referralType!: ReferralType;

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  @Action("enableMainMenu")
  enableMainMenu!: ActionMethod;

  beforeMount(): void {
    this.enableMainMenu(false);
  }
}
